export const environment = {
    production: false,
    apiHost: "https://dev.famhive.net/v1",
  };
  